import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import defaultStyle from './search.style.js';

export class SearchComponent extends Component {
  constructor(props) {
    super(props);
    this.keyDown = this.keyDown.bind(this);
  }

  /**
   * Perform specific behavior based on certain key input.
   * For now, we want to trigger a search if ENTER was pressed in the search box,
   * as long as the search input is not null and not empty.
   * @param {object} keyEvent The event corresponding to the key that was pressed.
   */
  keyDown( keyEvent ) {
    const { startSearch, searchInput } = this.props;
    if ( searchInput !== null && searchInput !== '' && (( keyEvent.keyCode || keyEvent.which ) === 13) ) {   // ENTER
      startSearch();
    }
  }

  render() {
    const { id, searchInput, searchQuery, searchButtonLabel, searchTermLabel, instructionText, setSearchText, startSearch, css } = this.props;
    return (
      <div>
         <span id='instructions'>{instructionText}</span>
         <div>
           <input
             className={css.input}
             id={id + '-searchBox'}
             type="text"
             aria-label='search.'
             aria-describedby='instructions'
             onChange={e => setSearchText(e.target.value)}
             onKeyDown={e => this.keyDown(e)}
             value={searchInput ? searchInput : ''}/>
           <button
             id={id + '-searchButton'}
             disabled={!searchInput}
             className={css.searchButton}
             onClick={e => startSearch()}>
             {searchButtonLabel}
           </button>
         </div>
         {!searchQuery ? null :
          <div className={css.searchTermList}>
            <span id={id + '-termLabel'}>{searchTermLabel}</span>
            <div className={css.searchTerm}>
              <span id={id + '-query'}>{searchQuery}</span>
              <button
                id={id + '-clear'}
                aria-label={'clear filter, ' + searchQuery}
                className={css.clearButton}
                onClick={e => {
                  setSearchText('');
                  startSearch();
                }}>
                &times;
              </button>
            </div>
          </div>}
      </div>
     );
  }
}

SearchComponent.defaultProps = {
  searchButtonLabel : 'Search',
  searchTermLabel : 'Search Term:'
}

SearchComponent.propTypes = {
  searchInput : PropTypes.string,
  searchQuery : PropTypes.string,
  searchButtonLabel : PropTypes.string,
  searchTermLabel : PropTypes.string,
  instructionText : PropTypes.string,
  setSearchText : PropTypes.func,
  startSearch : PropTypes.func
};

export default styleable(defaultStyle) (SearchComponent);
